import axios from "axios";
import { settings } from "../data/settings";

export const loadJSON = async (fileName) => {
  try {
    /*
    const response = await fetch(
      `${settings.storageDirFromScript}${fileName}.json`
    );
    if (!response.ok) {
      if (response.status === 404) {
        console.warn(
          `Le fichier ${fileName}.json est introuvable, création d'un fichier par défaut.`
        );
        return await createDefaultPageJSON(fileName);
      }
      throw new Error(`Erreur HTTP: ${response.status}`);
    }
    return await response.json();*/
    try {
      const storagePath = settings.storageDirFromScript;
      const response = await fetch(
        settings.websiteName + settings.scriptsDir +
          `fetchData.php?file=${fileName}.json&storagePath=${encodeURIComponent(
            storagePath
          )}`
      );

      // Vérification si la réponse est OK
      if (!response.ok) {
        throw new Error("Erreur lors de la récupération des données");
      }

      // Vérification de l'en-tête Content-Type
      const contentType = response.headers.get("Content-Type");
      console.log("Content-Type:", contentType);
      console.log(
        "FETCH FILE :",
        settings.websiteName + settings.scriptsDir +
          `fetchData.php?file=${fileName}.json&storagePath=${encodeURIComponent(
            storagePath
          )}`
      );

      if (contentType && contentType.includes("application/json")) {
        const result = await response.json();
        const resultJson = await JSON.parse(result);

        return resultJson;
        // Vérification que le format des données est correct
        /*if (Array.isArray(resultJson)) {
          const dataObject = resultJson.reduce((acc, item) => {
            acc[item.id] = item.value; // Utiliser l'id comme clé
            return acc;
          }, {});

          setData(dataObject);
        } else {
          console.error(
            "Les données retournées ne sont pas valides:",
            resultJson
          );
        }*/
      } else {
        // Si la réponse n'est pas du JSON, afficher et vérifier le contenu
        const textData = await response.text();
        console.log("Réponse brute non JSON:", textData);
        throw new Error("La réponse n'est pas du JSON");
      }
    } catch (error) {
      console.error("Erreur :", error);
    }
  } catch (error) {
    console.error(
      `Erreur lors du chargement du fichier ${fileName}.json :`,
      error
    );
    return null;
  }
};

const createDefaultPageJSON = async (fileName) => {
  const defaultData = {
    timestamp: Date.now(),
    title: fileName.replace("-", " ").toUpperCase(),
    elements: [
      { id: "1", type: "text", content: `Bienvenue sur la page ${fileName}.` },
    ],
  };

  try {
    await saveJSON(fileName, defaultData);
    return defaultData;
  } catch (error) {
    console.error(`Impossible de créer ${fileName}.json :`, error);
    return null;
  }
};

export const saveJSON = async (fileName, data) => {
  try {
    console.log(settings.websiteName + settings.scriptsDir + "savePageData.php");
    console.log(settings.storageDirFromScript + fileName + ".json");
    console.log("data", data);
    const response = await axios.post(
      settings.websiteName + settings.scriptsDir + "savePageData.php", // URL de votre script PHP
      {
        file: `${fileName}.json`, // Fichier à sauvegarder
        storagePath: settings.storageDirFromScript, // Chemin de stockage
        data: data, // Les données à sauvegarder
      },
      {
        headers: {
          "Content-Type": "application/json", // Spécifiez que les données envoyées sont en JSON
        },
      }
    );
    console.log("response", response);
    if (response.status === 200 && (response?.statusText === "OK" || response.data.status === "success")) {
      console.log(`✅ ${fileName}.json enregistré avec succès !`);
    } else {
      console.error("❌ Erreur lors de la sauvegarde");
    }
  } catch (error) {
    console.error("❌ Erreur réseau :", error);
  }
};

export const checkForUpdates = async (pageKey, setContent) => {
  let data = await loadJSON(pageKey);

  if (!data) {
    console.warn(`Création d'un nouveau fichier ${pageKey}.json`);
    data = { timestamp: Date.now(), title: pageKey, elements: [] };
    //await saveJSON(pageKey, data);
  } else {
    console.log("data", data);
  }

  try {
    const previousTimestamp = localStorage.getItem(`timestamp_${pageKey}`);

    if (data.timestamp !== previousTimestamp) {
      localStorage.setItem(`timestamp_${pageKey}`, data.timestamp);
      localStorage.setItem(`content_${pageKey}`, JSON.stringify(data));
      console.log("🔄 Mise à jour du localStorage.");
    } else {
      const cachedData = localStorage.getItem(`content_${pageKey}`);
      if (cachedData) {
        setContent(JSON.parse(cachedData));
        return;
      }
    }

    setContent(data);
  } catch (e) {
    if (
      e instanceof DOMException &&
      (e.name === "QuotaExceededError" || e.code === 22)
    ) {
      console.warn("⚠️ Quota dépassé, vidage du localStorage...");
      localStorage.clear();
      alert(
        "L'espace de stockage local est plein. Le cache a été réinitialisé."
      );
    } else {
      console.error("Erreur lors de l'accès au localStorage :", e);
    }

    // En dernier recours, afficher les données quand même
    setContent(data);
  }
};
